module.exports = __webpack_public_path__ + "static/media/long-arrow-right.34396061.svg";